import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { API_CONFIG } from '../config/api.config';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  constructor(
    private meta: Meta,
    private title: Title
  ) {}

  updateEventMeta(event: {
    nombre: string;
    descripcion?: string | null;
    imagenes?: { cuadrada?: string | null };
    imagen_principal?: string | null;
    fecha_inicio?: string | null;
    lugar?: string | null;
    ciudad?: string | null;
    pais?: string | null;
    url_slug?: string | null;
  }, baseUrl?: string): void {
    const siteName = API_CONFIG.seo?.siteName || 'Sitio';
    const siteSuffix = `| ${siteName}`;
    const eventTitle = (event.nombre || '').includes(siteSuffix)
      ? event.nombre
      : `${event.nombre} ${siteSuffix}`;
    const eventDescription = event.descripcion || `Compra tickets para ${event.nombre}`;
    const eventImage = event.imagenes?.cuadrada || event.imagen_principal || '';
    const eventUrl = baseUrl ? `${baseUrl}/evento/${event.url_slug}` : '';
    const keywordParts = [event.nombre, 'tickets', 'eventos', event.ciudad, event.pais].filter(Boolean);

    // Update title
    this.title.setTitle(eventTitle);

    // Update meta tags
    this.meta.updateTag({ name: 'description', content: eventDescription });
    this.meta.updateTag({ name: 'keywords', content: keywordParts.join(', ') });

    // Open Graph tags
    this.meta.updateTag({ property: 'og:title', content: eventTitle });
    this.meta.updateTag({ property: 'og:description', content: eventDescription });
    this.meta.updateTag({ property: 'og:image', content: eventImage });
    this.meta.updateTag({ property: 'og:type', content: 'event' });
    
    if (eventUrl) {
      this.meta.updateTag({ property: 'og:url', content: eventUrl });
    }

    if (event.fecha_inicio) {
      this.meta.updateTag({ property: 'event:start_time', content: event.fecha_inicio });
    }

    if (event.lugar) {
      this.meta.updateTag({ property: 'event:location', content: event.lugar });
    }

    // Twitter Card tags
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: eventTitle });
    this.meta.updateTag({ name: 'twitter:description', content: eventDescription });
    this.meta.updateTag({ name: 'twitter:image', content: eventImage });

    console.log('✅ Meta tags actualizados para evento:', event.nombre);
  }

  resetToDefault(defaultTitle?: string, defaultDescription?: string, defaultImage?: string, defaultUrl?: string): void {
    const siteName = API_CONFIG.seo?.siteName || 'Sitio';
    const title = defaultTitle || `${siteName} - Compra tickets para eventos en Ecuador`;
    const description = defaultDescription || `${siteName} es la plataforma lider en venta de tickets para eventos en Ecuador. Compra tus entradas de forma segura y rapida.`;
    const image = defaultImage || '';
    const url = defaultUrl || '';

    this.title.setTitle(title);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:image', content: image });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: image });

    // Remove event-specific tags
    this.meta.removeTag('property="event:start_time"');
    this.meta.removeTag('property="event:location"');
  }
}
